// WP-0.2 (FX-5): currency registry — amounts are stored as integer minor units
// (paisa/cents) with explicit currency; floating-point money math is prohibited.
// v1 registry per DEV_PLAN WP-0.2: PKR/USD/EUR/GBP. Further currencies addable per D-3.

export interface CurrencyInfo {
  readonly code: string;
  readonly name: string;
  /** Number of decimal digits in the major-unit representation (2 => 100 minor per major). */
  readonly decimalDigits: number;
  readonly minorPerMajor: number;
}

export const CURRENCIES = {
  PKR: { code: 'PKR', name: 'Pakistani Rupee', decimalDigits: 2, minorPerMajor: 100 },
  USD: { code: 'USD', name: 'US Dollar', decimalDigits: 2, minorPerMajor: 100 },
  EUR: { code: 'EUR', name: 'Euro', decimalDigits: 2, minorPerMajor: 100 },
  GBP: { code: 'GBP', name: 'Pound Sterling', decimalDigits: 2, minorPerMajor: 100 },
} as const satisfies Record<string, CurrencyInfo>;

export type CurrencyCode = keyof typeof CURRENCIES;

export function isCurrencyCode(value: string): value is CurrencyCode {
  return Object.hasOwn(CURRENCIES, value);
}

export function currencyInfo(code: CurrencyCode): CurrencyInfo {
  if (!isCurrencyCode(code)) {
    throw new MoneyError(`Unknown currency: ${String(code)}`);
  }
  return CURRENCIES[code];
}

/** All Money-domain failures throw this, so callers can distinguish them from bugs. */
export class MoneyError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'MoneyError';
  }
}
